import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { RangeValueAccessorDirective } from './range-value-accessor.directive';
import { LabelComponent } from '@knorr-bremse-portals/ngx-components/components/label';
import { ControlContainerComponent, InheritedControlValueAccessorComponent } from '@knorr-bremse-portals/ngx-components/internal/controls';

@Component({
  selector: 'kb-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ ControlContainerComponent, RangeValueAccessorDirective, LabelComponent ],
})
export class RangeComponent extends InheritedControlValueAccessorComponent<number> {

  protected controlId = `kb-range-${this.uniqueId}`;

  @Input() public step: number | 'any' = 'any';
  @Input() public min = 0;
  @Input({ required: true }) public max!: number;

  @ViewChild(RangeValueAccessorDirective, { static: true }) protected valueAccessor!: RangeValueAccessorDirective;
  @ViewChild('input', { static: true }) private inputElement!: ElementRef<HTMLInputElement>;

  protected getProgressBackground(): string {
    const value = parseFloat(this.inputElement.nativeElement.value);
    const percent = ((value - this.min) / (this.max - this.min)) * 100;
    return `linear-gradient(90deg, currentColor ${percent}%, var(--kb-color--background) ${percent}%)`;
  }

}
